import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Form } from 'antd';
import DspxModal from '../../../common/DspxModal/DspxModal';
import AddAccountForm from '../../forms/AddAccountForm/AddAccountForm';
import ModalSubtitle from '../../ModalSubtitle/ModalSubtitle';
import addAccount from '../../../../requests/addAccount';
import { texts } from '../../../../constants/texts';

const AddAccountModalNode = ({
  form,
  onCancel,
  address,
  addressId,
  withSelectFlat = false,
  withSelectHouse = false,
  queryKeys,
  ...props
}) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const queryClient = useQueryClient();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleCancel = () => {
    resetFields();
    onCancel();
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (!err) {
        setConfirmLoading(true);

        const keys = fieldValues['accountKeys'];

        await Promise.all(
          keys.map(async (key) => {
            const data = {
              addressId:
                addressId ||
                fieldValues.flatData.key ||
                fieldValues.flatData.value,
              typeId: fieldValues[`typeId-${key}`].key,
              account: fieldValues[`account-${key}`].trim(),
            };

            return await addAccount(data, fieldValues[`typeId-${key}`].label);
          })
        );

        queryKeys.forEach((key) => queryClient.invalidateQueries(key));

        setConfirmLoading(false);
        handleCancel();
      }
    });
  };

  return (
    <DspxModal
      wrapClassName="addAccountModal"
      title={texts.addPersonalAccount}
      okText={texts.add}
      cancelText={texts.cancel}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      destroyOnClose
      {...props}
    >
      {address && <ModalSubtitle subtitle={address} />}
      <AddAccountForm
        form={form}
        withSelectFlat={withSelectFlat}
        withSelectHouse={withSelectHouse}
      />
    </DspxModal>
  );
};

const AddAccountModal = Form.create({ name: 'add_account' })(
  AddAccountModalNode
);

export default AddAccountModal;
